import { GenericErrorBoundary } from "./GenericErrorBoundary";
import { BaseErrorBoundaryProps, TaskContext, createTaskState } from "./types";

interface Props extends BaseErrorBoundaryProps, TaskContext {}

export function TaskModalErrorBoundary(props: Props) {
  const { children, onError, ...contextProps } = props;

  return (
    <GenericErrorBoundary
      componentName="TaskModal"
      errorBoundaryName="TaskModalErrorBoundary"
      componentType="TaskModal"
      title="Task Modal Error"
      description="The task modal encountered an error. Please reload the page and try again."
      buttonText="Reload Page"
      onError={onError}
      context={contextProps}
      stateData={createTaskState(contextProps)}
    >
      {children}
    </GenericErrorBoundary>
  );
}
